<template>
    <div class="map-wrapper has-background-initial">
        <div class="map">
            <div id='map-canvas'></div>
            <!-- <TrailSearchBlock :searchItems="mapFilter" :pageType='null' @filterChange='filter_array=$event; filterAll()'/> -->
            </div>
            <!-- <TrailSearchBlock :searchItems="mapFilter" :pageType='null' @filterChange='filter_array=$event; filterAll()'/> -->
            <div v-if="searchGroups">
                <SearchGroupsBlock :searchGroups='searchGroups' @filterChange='filter_object=$event; filterAll()'/>
            </div>
            <div v-if="trailDesc" class="container trail-desc" style="line-height: 2rem;">
                <!-- <div class="row row-wrap" style="min-height: 500px;"> -->
                    <!-- <div class="column column-50"> -->
                        
                    <h2 v-if="! grouped_pages.length">No items match search</h2>
                    <transition-group name="list-complete" tag="div" class="row no-padding row-wrap">
                    
                        <div v-bind:key="item.pk"  v-for="item in grouped_pages" class="column column-50 trail-info-wrap">

                            <div class="rounded-border no-style trail-info has-background-initial">
                
                                <router-link :to="{ name: item.pk+'-slide'}">
                                <h4>{{ item.title }}<span v-if="item.trail_length > 0"> - {{ roundLength(item.trail_length)}} miles</span></h4>
                                </router-link>
                                <b><p v-if="item.latitude && item.longitude">Coordinates: {{ item.latitude }}, {{ item.longitude }}</p></b>
                                <div v-html="item.summary"></div>
                        
                            <!-- {{ trailAmentities[item.pk] }} -->
                            
                                <!-- <p v-if='trailAmentities'> -->
                            
                                <!-- <span v-for='node in trailAmentities[item.pk]' v-bind:key="node.name">
                                    <h1>IF IT IS</h1>
                                    <i v-if='node.icon' v-bind:class="['fas', 'fa-'+node.icon, 'fa-2x']" v-bind:title="node.name"></i>
                                    <span v-else>{{ node.name }}</span> | 
                                    </span>   
                                </p> -->
                                <p v-if='amenitiesListList[item.pk]'>
                                    <!-- <h1>am list</h1> -->
                                <span v-for='node in amenitiesListList[item.pk]' v-bind:key="node.name" class="am-icon">
                                    <i v-if='node.icon' v-bind:class="['fas', 'fa-'+node.icon, 'fa-2x']" v-bind:title="node.name"></i>
                                    <span v-else>{{ node.name }}</span> 
                                    </span>   
                                </p>
                            </div>
                        </div>
                    </transition-group>
                    <!-- </div> -->
                <!-- </div> -->
            <!-- <transition name="slide"> -->
         
                <!-- <div v-if="typeof($route.name) == 'string'"> -->
                    <div class="slide-overlay" v-if="slideOpen" @click="$router.push({ name: pageID })"></div>
                <!-- </div> -->
            <!-- </transition> -->
            <transition name="slide">
            <!-- <div v-if="typeof($route.name) == 'string'"> -->
                 
                <div class="slide-section" v-if="slideOpen">
                    <div class="container padding">
                        <router-view :backPageID="pageID"/>
                    </div>
                </div>
            <!-- </div> -->
            </transition>
        </div>
    </div>
</template>

<script>
import gmapsInit from '@/utils/gmaps'
import TrailSearchBlock from '@/components/TrailSearchBlock.vue'
import SearchGroupsBlock from '@/components/SearchGroupsBlock.vue'
import BasicMap from '@/components/BasicMap.vue'
import RelatedItems from '@/components/RelatedItems.vue'
import axios from 'axios'
export default {
    name: 'trailmap',
    data() {
        return {
            gmarkers: [],
            gmap: null,
            trails: [],
            filter_object: null,
            grouped_pages: [],
            map2: null,
            slide_data: null,
        }
    },
    props: {
        mapFilter: {
            type: Array,
            required: true,
        },
        trailDesc: false,
        searchGroups: {
            type: Array,
            default: () => new Array
        },
        colorKey: {
            type: Object,
            default: () => new Object
        },
        pageID: {
            type: Number
        }
    },
    components: {
        TrailSearchBlock,
        SearchGroupsBlock,
        BasicMap,
        RelatedItems
    },
    computed: {
        slideOpen() {
            if (typeof(this.$route.name) == 'string') {
                if (this.$route.name.endsWith('-slide')) {
                    return true
                }
            }
            return false
        },
        amenitiesListList() {
            let tempList = {}
            let parentNode = null
            // console.log('LIST LIST');
            for (var i in this.grouped_pages) {
                // console.log('IN LOOP');
                parentNode = null;
                for (var x in this.grouped_pages[i].node_data) {
                    // console.log('IN FOR LOOP: '+this.grouped_pages[i].node_data[x].name);
                    if (this.grouped_pages[i].node_data[x].name === 'Lodging Amenities') {
                        // console.log('IF PARENT NODE');
                        parentNode = this.grouped_pages[i].node_data[x];
                    }
                }
                let amnNode = [];
                if (parentNode) {
                    // console.log('IF PARENT NODE 2');
                    for (var y in this.grouped_pages[i].node_data) {
                        // console.log('VAR Y: '+ y);
                        if (this.grouped_pages[i].node_data[y].path.startsWith(parentNode.path) && this.grouped_pages[i].node_data[y].path !== parentNode.path) {
                            amnNode.push(this.grouped_pages[i].node_data[y])
                            // console.log('AMN NODE: '+amnNode);
                        }
                    }
                    tempList[this.grouped_pages[i].pk] = amnNode
                    // console.log('TEMP LIST: '+ JSON.stringify(tempList));
                }
            }
            return tempList
        },
        trailAmentities(){
            let tempList = {}
            // console.log('GORUP PAGES: '+ this.grouped_pages)
            for (var i in this.grouped_pages) {
                // console.log('I: ',i);
                let amnNode = [];
                for (var y in this.grouped_pages[i].node_data) {
                    // console.log("YYYYYYY"+ this.grouped_pages[i].node_data[y].name=='Lodging Amentities');
                    if (this.grouped_pages[i].node_data[y].name=='Lodging Amentities'){
                         amnNode.push(this.grouped_pages[i].node_data[y])
                    }
                    // console.log(amnNode);
                    // if (this.grouped_pages[i].node_data[y].path.startsWith(parentNode.path) && this.grouped_pages[i].node_data[y].path !== parentNode.path) {
                    //     amnNode.push(this.grouped_pages[i].node_data[y])
                    // }
                }
                tempList[this.grouped_pages[i].pk] = amnNode;
                // console.log(tempList);
            }
            return tempList;
        },
    },
    async mounted() {
        // try {
        //     const lewiscountyCoords = [{lng: -121.9045, lat: 46.73685},{lng: -121.87, lat: 46.73052},{lng: -121.85162, lat: 46.72965},{lng: -121.8368, lat: 46.72957},{lng: -121.82071, lat: 46.74413},{lng: -121.80681, lat: 46.75012},{lng: -121.8022, lat: 46.75877},{lng: -121.79044, lat: 46.76451},{lng: -121.78451, lat: 46.77167},{lng: -121.77397, lat: 46.77697},{lng: -121.76337, lat: 46.78139},{lng: -121.72144, lat: 46.7838},{lng: -121.45635, lat: 46.78374},{lng: -121.45511, lat: 46.78613},{lng: -121.45522, lat: 46.78556},{lng: -121.44757, lat: 46.77244},{lng: -121.44223, lat: 46.75863},{lng: -121.42424, lat: 46.75195},{lng: -121.41267, lat: 46.73569},{lng: -121.38551, lat: 46.72815},{lng: -121.36463, lat: 46.71009},{lng: -121.37444, lat: 46.69156},{lng: -121.40109, lat: 46.68585},{lng: -121.41241, lat: 46.66507},{lng: -121.40073, lat: 46.64614},{lng: -121.38886, lat: 46.63093},{lng: -121.40053, lat: 46.61099},{lng: -121.40574, lat: 46.58343},{lng: -121.42442, lat: 46.57063},{lng: -121.41975, lat: 46.55365},{lng: -121.44978, lat: 46.53411},{lng: -121.45532, lat: 46.51266},{lng: -121.42517, lat: 46.49375},{lng: -121.42825, lat: 46.46819},{lng: -121.41318, lat: 46.45818},{lng: -121.40817, lat: 46.43829},{lng: -121.38841, lat: 46.4123},{lng: -121.39268, lat: 46.39479},{lng: -121.43198, lat: 46.39017},{lng: -121.52001, lat: 46.38872},{lng: -121.52355, lat: 46.38871},{lng: -121.52421, lat: 46.38871},{lng: -121.55811, lat: 46.38865},{lng: -121.60378, lat: 46.3885},{lng: -121.64228, lat: 46.38855},{lng: -121.70782, lat: 46.38858},{lng: -121.74091, lat: 46.38806},{lng: -121.76617, lat: 46.38821},{lng: -121.82902, lat: 46.38904},{lng: -121.85471, lat: 46.38905},{lng: -121.87946, lat: 46.38753},{lng: -121.93121, lat: 46.38764},{lng: -121.95769, lat: 46.38753},{lng: -121.97741, lat: 46.3876},{lng: -122.01018, lat: 46.38805},{lng: -122.03532, lat: 46.38784},{lng: -122.07, lat: 46.38797},{lng: -122.09238, lat: 46.38822},{lng: -122.11444, lat: 46.38795},{lng: -122.15163, lat: 46.38624},{lng: -122.18627, lat: 46.38635},{lng: -122.20978, lat: 46.38617},{lng: -122.21618, lat: 46.38607},{lng: -122.22323, lat: 46.38599},{lng: -122.23027, lat: 46.38599},{lng: -122.23716, lat: 46.38589},{lng: -122.24097, lat: 46.38547},{lng: -122.24097, lat: 46.38537},{lng: -122.24479, lat: 46.38536},{lng: -122.28822, lat: 46.38553},{lng: -122.30962, lat: 46.38562},{lng: -122.34048, lat: 46.38562},{lng: -122.36707, lat: 46.38729},{lng: -122.40378, lat: 46.38715},{lng: -122.44529, lat: 46.3872},{lng: -122.47697, lat: 46.38715},{lng: -122.51585, lat: 46.38739},{lng: -122.55671, lat: 46.38763},{lng: -122.58957, lat: 46.38767},{lng: -122.60932, lat: 46.3876},{lng: -122.64662, lat: 46.38739},{lng: -122.689, lat: 46.38716},{lng: -122.71531, lat: 46.38735},{lng: -122.7481, lat: 46.38724},{lng: -122.79105, lat: 46.38738},{lng: -122.82982, lat: 46.3874},{lng: -122.87586, lat: 46.38735},{lng: -122.90734, lat: 46.38731},{lng: -122.94371, lat: 46.38739},{lng: -122.9935, lat: 46.38744},{lng: -123.04696, lat: 46.38769},{lng: -123.09313, lat: 46.38803},{lng: -123.14999, lat: 46.38641},{lng: -123.21309, lat: 46.3853},{lng: -123.21784, lat: 46.38513},{lng: -123.21803, lat: 46.38512},{lng: -123.22035, lat: 46.38509},{lng: -123.22855, lat: 46.38497},{lng: -123.23364, lat: 46.38489},{lng: -123.24417, lat: 46.38473},{lng: -123.24623, lat: 46.3847},{lng: -123.25124, lat: 46.38463},{lng: -123.25401, lat: 46.38462},{lng: -123.26002, lat: 46.38459},{lng: -123.2715, lat: 46.38455},{lng: -123.27219, lat: 46.38455},{lng: -123.28057, lat: 46.38452},{lng: -123.28475, lat: 46.3845},{lng: -123.29113, lat: 46.38448},{lng: -123.29637, lat: 46.38446},{lng: -123.30697, lat: 46.38442},{lng: -123.31757, lat: 46.38438},{lng: -123.32107, lat: 46.38437},{lng: -123.32161, lat: 46.38436},{lng: -123.32285, lat: 46.38436},{lng: -123.32474, lat: 46.38435},{lng: -123.32607, lat: 46.38435},{lng: -123.33279, lat: 46.38432},{lng: -123.34161, lat: 46.38429},{lng: -123.34814, lat: 46.38426},{lng: -123.35825, lat: 46.38403},{lng: -123.35833, lat: 46.38403},{lng: -123.35834, lat: 46.38475},{lng: -123.35847, lat: 46.40644},{lng: -123.35804, lat: 46.42368},{lng: -123.35817, lat: 46.4402},{lng: -123.3579, lat: 46.45301},{lng: -123.35739, lat: 46.47012},{lng: -123.35761, lat: 46.48407},{lng: -123.35824, lat: 46.49618},{lng: -123.35848, lat: 46.51655},{lng: -123.35846, lat: 46.53192},{lng: -123.35888, lat: 46.55143},{lng: -123.35934, lat: 46.55964},{lng: -123.36553, lat: 46.57782},{lng: -123.36497, lat: 46.59832},{lng: -123.36541, lat: 46.61997},{lng: -123.36503, lat: 46.63817},{lng: -123.36508, lat: 46.64779},{lng: -123.36609, lat: 46.66651},{lng: -123.36684, lat: 46.67938},{lng: -123.36792, lat: 46.69348},{lng: -123.36967, lat: 46.71315},{lng: -123.37113, lat: 46.7328},{lng: -123.372, lat: 46.75012},{lng: -123.37127, lat: 46.76642},{lng: -123.37123, lat: 46.77749},{lng: -123.37096, lat: 46.79185},{lng: -123.37095, lat: 46.79213},{lng: -123.37089, lat: 46.79245},{lng: -123.36625, lat: 46.7927},{lng: -123.35929, lat: 46.79315},{lng: -123.3517, lat: 46.79345},{lng: -123.34094, lat: 46.79339},{lng: -123.33049, lat: 46.79332},{lng: -123.31419, lat: 46.79323},{lng: -123.30815, lat: 46.79319},{lng: -123.29827, lat: 46.79313},{lng: -123.29303, lat: 46.7931},{lng: -123.28779, lat: 46.79307},{lng: -123.2826, lat: 46.79301},{lng: -123.27741, lat: 46.79297},{lng: -123.26379, lat: 46.79288},{lng: -123.26027, lat: 46.79286},{lng: -123.2601, lat: 46.79285},{lng: -123.25305, lat: 46.79281},{lng: -123.24599, lat: 46.7935},{lng: -123.23593, lat: 46.79344},{lng: -123.22006, lat: 46.79362},{lng: -123.20859, lat: 46.79413},{lng: -123.19765, lat: 46.79431},{lng: -123.18721, lat: 46.79415},{lng: -123.17811, lat: 46.79391},{lng: -123.1713, lat: 46.7937},{lng: -123.16252, lat: 46.79346},{lng: -123.16059, lat: 46.79343},{lng: -123.16063, lat: 46.79239},{lng: -123.15934, lat: 46.76433},{lng: -123.11354, lat: 46.76397},{lng: -123.03621, lat: 46.76451},{lng: -123.00287, lat: 46.76448},{lng: -122.96615, lat: 46.76426},{lng: -122.92397, lat: 46.76397},{lng: -122.87671, lat: 46.76368},{lng: -122.81849, lat: 46.76393},{lng: -122.77476, lat: 46.7637},{lng: -122.73412, lat: 46.76379},{lng: -122.69911, lat: 46.76365},{lng: -122.66772, lat: 46.76351},{lng: -122.61579, lat: 46.76215},{lng: -122.56037, lat: 46.76336},{lng: -122.51655, lat: 46.76282},{lng: -122.48162, lat: 46.76305},{lng: -122.44981, lat: 46.76297},{lng: -122.4055, lat: 46.76283},{lng: -122.38601, lat: 46.76287},{lng: -122.36485, lat: 46.76314},{lng: -122.34143, lat: 46.76305},{lng: -122.31911, lat: 46.76296},{lng: -122.27715, lat: 46.76305},{lng: -122.25616, lat: 46.76294},{lng: -122.20294, lat: 46.76312},{lng: -122.20272, lat: 46.76263},{lng: -122.20262, lat: 46.76253},{lng: -122.1757, lat: 46.75626},{lng: -122.14552, lat: 46.75323},{lng: -122.12622, lat: 46.75306},{lng: -122.10817, lat: 46.75009},{lng: -122.07637, lat: 46.75081},{lng: -122.05428, lat: 46.74694},{lng: -122.02808, lat: 46.7437},{lng: -122.01117, lat: 46.74958},{lng: -121.99419, lat: 46.75098},{lng: -121.97773, lat: 46.74441},{lng: -121.95325, lat: 46.75401},{lng: -121.93429, lat: 46.74492}];
        //     const lewiscountyCenter = { lat: 46.5900, lng: -122.4555 };
        //     const google = await gmapsInit();
        //     // const geocoder = new google.maps.Geocoder();
        //     const map = new google.maps.Map(document.getElementById('map-canvas'), {
        //         zoom: 10,
        //         minZoom: 9,
        //         maxZoom: 12,
        //         center: lewiscountyCenter,
        //         mapTypeId: 'terrain'
        //     });

        //     const lewiscountyPoly = new google.maps.Polygon({
        //         paths: lewiscountyCoords,
        //         strokeColor: '#000000',
        //         strokeOpacity: 0.8,
        //         strokeWeight: 2,
        //         fillColor: '#000000',
        //         fillOpacity: 0.00
        //     });
            
        //     lewiscountyPoly.setMap(map);

        //     // Looping through all the entries from the JSON data
        //     console.log('TEST MAP', this.trails)
        //     for (var i = 0; i < this.trails.length; i++) {
        //         console.log('Loop');
        //         // console.log(map);
        //         this.createMarkers(this.trails[i], i, map, google)
        //     }
        //     google.maps.event.addListener(lewiscountyPoly, 'click', this.hide_popups);
        //     google.maps.event.addListener(map, 'click', this.hide_popups);
        // }
        // catch (error) {
        //     console.error(error)
        // }
    },
    created () {
        this.fetchData().then(data =>{
            this.trails = data;
            this.grouped_pages = this.trails;
            this.buildMap();
            // Timeout to wait for map to finish being craeted
            // Done in create so that it only does it when navigating to slide out from another component
            setTimeout(temp => {
                // check if the current route is a nested one
                if (this.$route.matched.length > 1) {
                    // console.log("This is the id for the current route: ", this.$route.meta.id);
                    let open_id = 'popup-'+this.$route.meta.id;
                    // console.log("This is the open_id: ", open_id)
                    for (let marker in this.gmarkers) {
                        if (this.gmarkers[marker].popup == open_id) {
                            this.gmap.maps.event.trigger(this.gmarkers[marker], 'mouseover');
                        }
                    }
                    document.getElementsByClassName(open_id).forEach(function(e) {
                        e.classList.add('hold-open');
                    })
                }
            },
            5000
            );
        });
    },
    watch:{
        '$route': 'fetchData'
    },
    methods: {
        fetchData() {
            return axios.get('/api/map_data_by_id?id='+this.pageID).then(response => {
                return response.data
            })
        },
        roundLength(e){
            if (e > 0){
                return Math.round(e * 10) / 10
            }
        },
        toPage(e){
            console.log('TO PAGE: ',e)
            this.$router.push({ path: e.dataset.link })
        },
        filterAll() {
            if (this.currentDateFilter){
                this.filterDate(this.currentDateFilter);
            }
            this.handleFilter(this.filter_object);
        },
        handleFilter(filter_object){
            this.filter_object = filter_object;
            if (filter_object) {
                var temp_grouped_pages = this.trails;

                var empty_filters = [];
                var filter_array = filter_object.filters

                temp_grouped_pages = temp_grouped_pages.filter(page => {
                    for (let so in filter_object.showOnly) {
                        if (page.url_path.startsWith(filter_object.showOnly[so])) {
                            return true
                        }
                    }
                    return false;
                })

                for (let filter in filter_array) {
                    let filter_for = filter_array[filter].filter_for;
                    if (filter_array[filter].dates != null) {
                        let startFilterDatelets = filter_array[filter].dates.startDateFilter.split('-')
                        let endFIlterDatelets = filter_array[filter].dates.endDateFilter.split('-')
                        let startDateFilter = new Date(startFilterDatelets[0], startFilterDatelets[1]-1, startFilterDatelets[2])
                        let endDateFilter = new Date(endFIlterDatelets[0], endFIlterDatelets[1]-1, endFIlterDatelets[2])
                        temp_grouped_pages = temp_grouped_pages.filter(page => {
                            if (page.url_path.startsWith(filter_for)) {
                                if (page.start_date != null && page.end_date != null) {
                                    let startDatelets = page.start_date.split('-')
                                    let endDatelets = page.end_date.split('-')
                                    let startDate = new Date(startDatelets[0], startDatelets[1]-1, startDatelets[2])
                                    let endDate = new Date(endDatelets[0], endDatelets[1]-1, endDatelets[2])
                                    
                                    if ((startDate >= startDateFilter || endDate >= startDateFilter) && (startDate <= endDateFilter || endDate <= endDateFilter)) {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                }
                                return true;
                            }
                            return true;
                        })
                    }
                    for (let f in filter_array[filter].options) {
                        if (filter_array[filter].options[f].length > 0){
                            temp_grouped_pages = temp_grouped_pages.filter(page => {
                                if (page.url_path.startsWith(filter_for)) {
                                    let intersection = page.node_data.filter(x => filter_array[filter].options[f].includes(x.id));
                                    if (intersection.length > 0){
                                        return true;
                                    }
                                    return false;
                                }
                                return true;
                            });
                        }
                    }
                }
            
                let textFilter = filter_object.textFilter;
                if (textFilter !== '' && textFilter !== ' ' && textFilter !== null) {
                    // Split the text filter into an array and remove empty words
                    let fWords = textFilter.toLowerCase().split(' ')
                    fWords = fWords.filter(word => {
                        if (word == '') {
                            return false;
                        }
                        return true;
                    })
                    console.log(fWords)
                    temp_grouped_pages = temp_grouped_pages.filter(page => {
                        //// START Must in include all the filter words
                        // //return fWords.every(w => page.title.toLowerCase().includes(w))
                        let usedWords = []
                        for (let w in fWords) {
                            if (page.title.toLowerCase().includes(fWords[w])) {
                                // if (!usedWords.includes(fWords[w])) {
                                    usedWords.push(fWords[w])
                                // }
                            }
                            for (let n in page.node_data) {
                                if (page.node_data[n].name.toLowerCase().includes(fWords[w])) {
                                    // if (!usedWords.includes(fWords[w])) {
                                        usedWords.push(fWords[w])
                                    // }
                                }
                            }
                        }
                        return fWords.every(w => usedWords.includes(w))
                        //// END 

                        // #########

                        //// Start Can only include one of the filter words
                        //// may be eaiser to filter on multiple fields this way?
                        // for (let w in fWords){
                        //     if (page.title.toLowerCase().includes(fWords[w])) {
                        //         return true;
                        //     }
                        //     for (let node in page.node_data){
                        //         if (page.node_data[node].name.toLowerCase().includes(fWords[w])) {
                        //             return true;
                        //         }
                        //     }
                        // }
                        // return false;
                        //// END
                    })
                }
                this.grouped_pages = temp_grouped_pages;
                this.redrawMarkers();
            }
        },
        redrawMarkers() {
            if (! this.grouped_pages.length){
                for (var i = 0; i < this.gmarkers.length; i++) {
                    this.gmarkers[i].setMap(null);
                }
            }else if(this.grouped_pages.length === this.trails.length){
                for (var i = 0; i < this.gmarkers.length; i++) {
                    this.gmarkers[i].setMap(this.map2);
                }
            } else{
                var filt =''
                for (var i = 0; i < this.gmarkers.length; i++) {
                    filt = this.grouped_pages.filter(gpage => gpage.pk === this.gmarkers[i].markerID)
                    if (filt.length > 0){
                        this.gmarkers[i].setMap(this.map2)
                    }else{
                        this.gmarkers[i].setMap(null)
                    }
                }
            }
        },
        showMarker(){
            console.log('MAPPY: ',this.map)
            this.gmarkers[1].setMap(this.map2)
        },
        fetchPointData(pk) {
            return axios.get('/api/v2/pages/'+ pk).then(response => {
                return response.data;
            });
        },
        async buildMap(){   
            try {
                const lewiscountyCoords = [{lng: -121.9045, lat: 46.73685},{lng: -121.87, lat: 46.73052},{lng: -121.85162, lat: 46.72965},{lng: -121.8368, lat: 46.72957},{lng: -121.82071, lat: 46.74413},{lng: -121.80681, lat: 46.75012},{lng: -121.8022, lat: 46.75877},{lng: -121.79044, lat: 46.76451},{lng: -121.78451, lat: 46.77167},{lng: -121.77397, lat: 46.77697},{lng: -121.76337, lat: 46.78139},{lng: -121.72144, lat: 46.7838},{lng: -121.45635, lat: 46.78374},{lng: -121.45511, lat: 46.78613},{lng: -121.45522, lat: 46.78556},{lng: -121.44757, lat: 46.77244},{lng: -121.44223, lat: 46.75863},{lng: -121.42424, lat: 46.75195},{lng: -121.41267, lat: 46.73569},{lng: -121.38551, lat: 46.72815},{lng: -121.36463, lat: 46.71009},{lng: -121.37444, lat: 46.69156},{lng: -121.40109, lat: 46.68585},{lng: -121.41241, lat: 46.66507},{lng: -121.40073, lat: 46.64614},{lng: -121.38886, lat: 46.63093},{lng: -121.40053, lat: 46.61099},{lng: -121.40574, lat: 46.58343},{lng: -121.42442, lat: 46.57063},{lng: -121.41975, lat: 46.55365},{lng: -121.44978, lat: 46.53411},{lng: -121.45532, lat: 46.51266},{lng: -121.42517, lat: 46.49375},{lng: -121.42825, lat: 46.46819},{lng: -121.41318, lat: 46.45818},{lng: -121.40817, lat: 46.43829},{lng: -121.38841, lat: 46.4123},{lng: -121.39268, lat: 46.39479},{lng: -121.43198, lat: 46.39017},{lng: -121.52001, lat: 46.38872},{lng: -121.52355, lat: 46.38871},{lng: -121.52421, lat: 46.38871},{lng: -121.55811, lat: 46.38865},{lng: -121.60378, lat: 46.3885},{lng: -121.64228, lat: 46.38855},{lng: -121.70782, lat: 46.38858},{lng: -121.74091, lat: 46.38806},{lng: -121.76617, lat: 46.38821},{lng: -121.82902, lat: 46.38904},{lng: -121.85471, lat: 46.38905},{lng: -121.87946, lat: 46.38753},{lng: -121.93121, lat: 46.38764},{lng: -121.95769, lat: 46.38753},{lng: -121.97741, lat: 46.3876},{lng: -122.01018, lat: 46.38805},{lng: -122.03532, lat: 46.38784},{lng: -122.07, lat: 46.38797},{lng: -122.09238, lat: 46.38822},{lng: -122.11444, lat: 46.38795},{lng: -122.15163, lat: 46.38624},{lng: -122.18627, lat: 46.38635},{lng: -122.20978, lat: 46.38617},{lng: -122.21618, lat: 46.38607},{lng: -122.22323, lat: 46.38599},{lng: -122.23027, lat: 46.38599},{lng: -122.23716, lat: 46.38589},{lng: -122.24097, lat: 46.38547},{lng: -122.24097, lat: 46.38537},{lng: -122.24479, lat: 46.38536},{lng: -122.28822, lat: 46.38553},{lng: -122.30962, lat: 46.38562},{lng: -122.34048, lat: 46.38562},{lng: -122.36707, lat: 46.38729},{lng: -122.40378, lat: 46.38715},{lng: -122.44529, lat: 46.3872},{lng: -122.47697, lat: 46.38715},{lng: -122.51585, lat: 46.38739},{lng: -122.55671, lat: 46.38763},{lng: -122.58957, lat: 46.38767},{lng: -122.60932, lat: 46.3876},{lng: -122.64662, lat: 46.38739},{lng: -122.689, lat: 46.38716},{lng: -122.71531, lat: 46.38735},{lng: -122.7481, lat: 46.38724},{lng: -122.79105, lat: 46.38738},{lng: -122.82982, lat: 46.3874},{lng: -122.87586, lat: 46.38735},{lng: -122.90734, lat: 46.38731},{lng: -122.94371, lat: 46.38739},{lng: -122.9935, lat: 46.38744},{lng: -123.04696, lat: 46.38769},{lng: -123.09313, lat: 46.38803},{lng: -123.14999, lat: 46.38641},{lng: -123.21309, lat: 46.3853},{lng: -123.21784, lat: 46.38513},{lng: -123.21803, lat: 46.38512},{lng: -123.22035, lat: 46.38509},{lng: -123.22855, lat: 46.38497},{lng: -123.23364, lat: 46.38489},{lng: -123.24417, lat: 46.38473},{lng: -123.24623, lat: 46.3847},{lng: -123.25124, lat: 46.38463},{lng: -123.25401, lat: 46.38462},{lng: -123.26002, lat: 46.38459},{lng: -123.2715, lat: 46.38455},{lng: -123.27219, lat: 46.38455},{lng: -123.28057, lat: 46.38452},{lng: -123.28475, lat: 46.3845},{lng: -123.29113, lat: 46.38448},{lng: -123.29637, lat: 46.38446},{lng: -123.30697, lat: 46.38442},{lng: -123.31757, lat: 46.38438},{lng: -123.32107, lat: 46.38437},{lng: -123.32161, lat: 46.38436},{lng: -123.32285, lat: 46.38436},{lng: -123.32474, lat: 46.38435},{lng: -123.32607, lat: 46.38435},{lng: -123.33279, lat: 46.38432},{lng: -123.34161, lat: 46.38429},{lng: -123.34814, lat: 46.38426},{lng: -123.35825, lat: 46.38403},{lng: -123.35833, lat: 46.38403},{lng: -123.35834, lat: 46.38475},{lng: -123.35847, lat: 46.40644},{lng: -123.35804, lat: 46.42368},{lng: -123.35817, lat: 46.4402},{lng: -123.3579, lat: 46.45301},{lng: -123.35739, lat: 46.47012},{lng: -123.35761, lat: 46.48407},{lng: -123.35824, lat: 46.49618},{lng: -123.35848, lat: 46.51655},{lng: -123.35846, lat: 46.53192},{lng: -123.35888, lat: 46.55143},{lng: -123.35934, lat: 46.55964},{lng: -123.36553, lat: 46.57782},{lng: -123.36497, lat: 46.59832},{lng: -123.36541, lat: 46.61997},{lng: -123.36503, lat: 46.63817},{lng: -123.36508, lat: 46.64779},{lng: -123.36609, lat: 46.66651},{lng: -123.36684, lat: 46.67938},{lng: -123.36792, lat: 46.69348},{lng: -123.36967, lat: 46.71315},{lng: -123.37113, lat: 46.7328},{lng: -123.372, lat: 46.75012},{lng: -123.37127, lat: 46.76642},{lng: -123.37123, lat: 46.77749},{lng: -123.37096, lat: 46.79185},{lng: -123.37095, lat: 46.79213},{lng: -123.37089, lat: 46.79245},{lng: -123.36625, lat: 46.7927},{lng: -123.35929, lat: 46.79315},{lng: -123.3517, lat: 46.79345},{lng: -123.34094, lat: 46.79339},{lng: -123.33049, lat: 46.79332},{lng: -123.31419, lat: 46.79323},{lng: -123.30815, lat: 46.79319},{lng: -123.29827, lat: 46.79313},{lng: -123.29303, lat: 46.7931},{lng: -123.28779, lat: 46.79307},{lng: -123.2826, lat: 46.79301},{lng: -123.27741, lat: 46.79297},{lng: -123.26379, lat: 46.79288},{lng: -123.26027, lat: 46.79286},{lng: -123.2601, lat: 46.79285},{lng: -123.25305, lat: 46.79281},{lng: -123.24599, lat: 46.7935},{lng: -123.23593, lat: 46.79344},{lng: -123.22006, lat: 46.79362},{lng: -123.20859, lat: 46.79413},{lng: -123.19765, lat: 46.79431},{lng: -123.18721, lat: 46.79415},{lng: -123.17811, lat: 46.79391},{lng: -123.1713, lat: 46.7937},{lng: -123.16252, lat: 46.79346},{lng: -123.16059, lat: 46.79343},{lng: -123.16063, lat: 46.79239},{lng: -123.15934, lat: 46.76433},{lng: -123.11354, lat: 46.76397},{lng: -123.03621, lat: 46.76451},{lng: -123.00287, lat: 46.76448},{lng: -122.96615, lat: 46.76426},{lng: -122.92397, lat: 46.76397},{lng: -122.87671, lat: 46.76368},{lng: -122.81849, lat: 46.76393},{lng: -122.77476, lat: 46.7637},{lng: -122.73412, lat: 46.76379},{lng: -122.69911, lat: 46.76365},{lng: -122.66772, lat: 46.76351},{lng: -122.61579, lat: 46.76215},{lng: -122.56037, lat: 46.76336},{lng: -122.51655, lat: 46.76282},{lng: -122.48162, lat: 46.76305},{lng: -122.44981, lat: 46.76297},{lng: -122.4055, lat: 46.76283},{lng: -122.38601, lat: 46.76287},{lng: -122.36485, lat: 46.76314},{lng: -122.34143, lat: 46.76305},{lng: -122.31911, lat: 46.76296},{lng: -122.27715, lat: 46.76305},{lng: -122.25616, lat: 46.76294},{lng: -122.20294, lat: 46.76312},{lng: -122.20272, lat: 46.76263},{lng: -122.20262, lat: 46.76253},{lng: -122.1757, lat: 46.75626},{lng: -122.14552, lat: 46.75323},{lng: -122.12622, lat: 46.75306},{lng: -122.10817, lat: 46.75009},{lng: -122.07637, lat: 46.75081},{lng: -122.05428, lat: 46.74694},{lng: -122.02808, lat: 46.7437},{lng: -122.01117, lat: 46.74958},{lng: -121.99419, lat: 46.75098},{lng: -121.97773, lat: 46.74441},{lng: -121.95325, lat: 46.75401},{lng: -121.93429, lat: 46.74492}];
                const lewiscountyCenter = { lat: 46.5900, lng: -122.4555 };
                const google = await gmapsInit();
                const map = new google.maps.Map(document.getElementById('map-canvas'), {
                    zoom: 10,
                    minZoom: 9,
                    maxZoom: 20,
                    center: lewiscountyCenter,
                    mapTypeId: 'terrain',
                    fullscreenControl: false
                });
                this.map2 = map

                const lewiscountyPoly = new google.maps.Polygon({
                    paths: lewiscountyCoords,
                    strokeColor: '#000000',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: '#000000',
                    fillOpacity: 0.00
                });
                
                lewiscountyPoly.setMap(map);

                // Looping through all the entries from the JSON data
                for (var i = 0; i < this.grouped_pages.length; i++) {
                    this.createMarkers(this.grouped_pages[i], i, map, google);
                }
                google.maps.event.addListener(lewiscountyPoly, 'mouseover', this.hide_popups);
                google.maps.event.addListener(map, 'mouseover', this.hide_popups);
                let ref = this;
                document.addEventListener('click', function(e){
                    // If the close button has been clicked then close the popup.
                    if (e.target.classList.contains('fa-window-close') && !e.target.classList.contains('for-slide')){
                        e.target.closest('.popup-container').style.visibility = 'hidden';
                        e.target.closest('.popup-bubble').classList.remove('from-bottom');
                    }
                    if (e.target.classList.contains('map-link')){
                        e.preventDefault()
                        ref.toPage(e.target)
                    }
                    if (e.target.classList.contains('slide-info')) {
                        e.preventDefault();
                        e.target.closest('.popup-container').classList.add('hold-open');
                        // console.log("Clicked on: ", e.target.dataset.pk);
                        // console.log("Class List: ", e.target.closest('.popup-container').classList);
                        ref.fetchPointData(e.target.dataset.pk).then(data => { ref.slide_data = data });
                        ref.$router.push({ name: e.target.dataset.routename });
                    }
                });
                this.filterAll();
                this.gmap = google;
            }
            catch (error) {
                console.error(error)
            }
        },
        createMarkers(trail, index, map, google) {
            // Current object
                var map_pin_green =  {
                    url: require("../assets/images/map-pin6.png"),
                    size: new google.maps.Size(20, 25),
                    scaledSize: new google.maps.Size(20, 25)
                    };
                var map_pin_orange =  {
                    url: require("../assets/images/map-pin-orange.png"),
                    size: new google.maps.Size(20, 25),
                    scaledSize: new google.maps.Size(20, 25)
                    };
                var map_pin_blue =  {
                    url: require("../assets/images/map-pin-blue.png"),
                    size: new google.maps.Size(20, 25),
                    scaledSize: new google.maps.Size(20, 25)
                    };

                var pin_colors = {
                    'green': map_pin_green,
                    'orange': map_pin_orange,
                    'blue': map_pin_blue
                }

                // console.log('ICON: '+ icon);
                var ref = this
                var obj = trail;
                var trailLength = [];
                // console.log(obj);
                // console.log('TRAIL: ', trail.title)
                var overlay;
                overlay = new google.maps.OverlayView();
                overlay.draw = function () {};
                overlay.setMap(map);

                var pos = new google.maps.LatLng(trail["latitude"], trail["longitude"]);

                // pos_pixel = map.getProjection().fromLatLngToPoint(pos.lat(), pos.long());
            
                var category = trail["trail-type"];
            
                // if (trail["trail-length"] > 10) {
                //     trailLength[index] = 10;
                // }
                // else {
                //     trailLength[index] = trail["trail-length"];
                // };
                // category.unshift(trailLength[index]);

                // Adding a new marker for the object
                var map_pin_color = 'green'

                var colKeys = Object.keys(ref.colorKey)
                for (let key in colKeys) {
                    if (trail.url_path.startsWith(colKeys[key])) {
                        map_pin_color = ref.colorKey[colKeys[key]];
                    }
                }

                if (!pin_colors.hasOwnProperty(map_pin_color)) {
                    map_pin_color = 'green';
                }

                var trailMarker = new google.maps.Marker({
                    position: pos,
                    map: map,
                    title: trail["title"],
                    category: category,
                    visible: true,
                    popup: 'popup-'+trail['pk'],
                    markerID: trail['pk'],
                    icon: pin_colors[map_pin_color]
                })

                // Adding a new marker for the object
                // if (trail.parent_id == 93) {
                //     var trailMarker = new google.maps.Marker({
                //         position: pos,
                //         map: map,
                //         title: trail["title"],
                //         category: category,
                //         visible: true,
                //         popup: 'popup-'+index,
                //         markerID: trail['pk'],
                //         icon: map_pin_orange,
                //     });
                // } else if (trail.parent_id == 4) {
                //     var trailMarker = new google.maps.Marker({
                //         position: pos,
                //         map: map,
                //         title: trail["title"],
                //         category: category,
                //         visible: true,
                //         popup: 'popup-'+index,
                //         markerID: trail['pk'],
                //         icon: map_pin_blue,
                //     });
                // } else if (trail.parent_id == 253) {
                //     var trailMarker = new google.maps.Marker({
                //         position: pos,
                //         map: map,
                //         title: trail["title"],
                //         category: category,
                //         visible: true,
                //         popup: 'popup-'+index,
                //         markerID: trail['pk'],
                //         icon: map_pin_green,
                //     });
                // }
                this.gmarkers.push(trailMarker);
                // console.log('New trailMarker added');
                // console.log(trailMarker);
                //Event listener for markers
                google.maps.event.addListener(trailMarker, 'mouseover', function(e) {
                    var pos_pixel = overlay.getProjection().fromLatLngToContainerPixel(trailMarker.getPosition())
                    parent = document.querySelector('.'+trailMarker.popup);
                    var child = parent.querySelector('.popup-bubble');

                    // GET the thumbnail image for the popup
                    // console.log("How many Imgs: ", document.querySelector('.'+trailMarker.popup).getElementsByTagName('img'))
                    Array.prototype.forEach.call(document.querySelector('.'+trailMarker.popup).getElementsByTagName('img'), function(e){
                        // console.log(e.dataset.trailPk)
                        // console.log(e.src)
                        if (e.dataset.trailPk) {
                            if (e.getAttribute('src') == "") {
                                axios.get('/api/v2/pages/'+e.dataset.trailPk+'?fields=_,map_thumbnail').then(data => {
                                    // console.log(data)
                                    if (data.data.hasOwnProperty('map_thumbnail')) {
                                        if (data.data.map_thumbnail != null){
                                            // console.log(data.data.map_thumbnail.url)
                                            e.src = data.data.map_thumbnail.url
                                        }
                                    }
                                })
                            }
                        }
                    })
                
                    console.log('PIXEL Point: '+ pos_pixel.y );
                    if (pos_pixel.y <= child.offsetHeight){
                        console.log('Less than 100');
                        child.style.top = child.offsetHeight + 'px';
                        parent.classList.add('from-bottom')
                        // child.classList.add('from-bottom');
                        console.log(child.offsetHeight);
                    }
                    // console.log('Marker Clicked: '+ trailMarker.popup);
                    // console.log(document.getElementsByClassName('popup-container'));

                    Array.prototype.forEach.call(document.getElementsByClassName('popup-container'), function(e){
                        // e.classList.remove('hold-open')
                        e.style.visibility = 'hidden';
                    });
                    document.querySelector('.'+trailMarker.popup).style.visibility = 'visible';
                });
                
                var content = document.createElement('div');
                // console.log(trail['summary']);
                content.className += 'popup-window'
                content.insertAdjacentHTML('beforeend', '<div class="close"><i class="fas fa-window-close fa-2x"></i></div><h5 class="has-color-initial">'+trail["title"]+'</h5><img src="" width="100%" data-trail-pk="'+ trail['pk'] +'" aria-hidden="true">'+trail['summary']+'<button type="button" class="button slide-info" data-pk="'+ trail.pk +'" data-routename="'+ trail.pk +'-slide">More Info</button>');
                // content.insertAdjacentHTML('beforeend', '<div class="close"><i class="fas fa-window-close fa-2x"></i></div><h5 class="has-color-initial">'+trail["title"]+'</h5><img src="'+ thumbUrl +'" width="100%">'+trail['summary']+'<a href="'+trail.url_path+'" class="button map-link" data-link="'+trail.url_path+'">More Info</a><button type="button" class="button slide-info" data-pk="'+ trail.pk +'" data-routename="'+ trail.pk +'-slide">Slide Info</button>');
             
                var Popup = this.createPopupClass();
                var popup = new Popup(
                    pos,
                    content,
                    trail["title"]);
                popup.setMap(map);
                // console.log(map);
                // console.log(popup);
                popup.containerDiv.classList.add('popup-'+trail.pk);
        },
        hide_popups() {
            Array.prototype.forEach.call(document.getElementsByClassName('popup-container'), function(e) {
                if (!e.classList.contains('hold-open')) {
                    e.style.visibility = 'hidden';
                    e.classList.remove('from-bottom');
                }
            });
        },
        createPopupClass() {
            /**
             * A customized popup on the map.
             * @param {!google.maps.LatLng} position
             * @param {!Element} content The bubble div.
             * @param {!Element} title 
             * @constructor
             * @extends {google.maps.OverlayView}
             */
            function Popup(position, content, title) {
                this.position = position;
            
                // console.log(content);
                content.classList.add('popup-bubble');

                // This zero-height div is positioned at the bottom of the bubble.
                var bubbleAnchor = document.createElement('div');
                bubbleAnchor.classList.add('popup-bubble-anchor');
                bubbleAnchor.appendChild(content);

                // This zero-height div is positioned at the bottom of the tip.
                this.containerDiv = document.createElement('div');
                this.containerDiv.classList.add('popup-container');
                this.containerDiv.appendChild(bubbleAnchor);

                // Optionally stop clicks, etc., from bubbling up to the map.
                google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.containerDiv);
                function show(){
                this.containerDiv.style.display = 'visible';
                }
            
                function hide(){
                this.containerDiv.style.display = 'hidden';
                }
            }
            // ES5 magic to extend google.maps.OverlayView.
            Popup.prototype = Object.create(google.maps.OverlayView.prototype);

            /** Called when the popup is added to the map. */
            Popup.prototype.onAdd = function() {
                this.getPanes().floatPane.appendChild(this.containerDiv);
                
            };

            /** Called when the popup is removed from the map. */
            Popup.prototype.onRemove = function() {
                if (this.containerDiv.parentElement) {
                this.containerDiv.parentElement.removeChild(this.containerDiv);
                }
            };

            /** Called each frame when the popup needs to draw itself. */
            Popup.prototype.draw = function() {
                var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
                // console.log(divPosition.x);
                // divPosition.y = divPosition.y - 45;
                // divPosition.y = -200;
                // var inBounds = map.getBounds().contains(divPosition())
            
                // Hide the popup when it is far out of view.
                var display =
                    Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ?
                    'visible' :
                    'hidden';
                
                if (display === 'visible') {
                this.containerDiv.style.left = divPosition.x + 'px';
                this.containerDiv.style.top = divPosition.y + 'px';
                this.containerDiv.style.visibility = 'hidden';
                }
                if (this.containerDiv.style.display !== display) {
                this.containerDiv.style.display = display;
                this.containerDiv.style.visibility = 'hidden';
                }
                
            };
            return Popup;
        }
    },
}
</script>

<style scoped>

    .am-icon{
        margin-right: 1rem;
    }

    .trail-info-wrap{
        transition: all 1s;
    }
    .trail-info h4{
        margin-bottom: .5rem;
    }

    .trail-info{
         transition: all .5s;
         margin-bottom: 1.5rem;
         padding: .75rem 1rem;

    }

    .trail-desc{
        padding-top: 4rem;
    }

    #map-canvas{
        z-index: 2;
    }

    .map{
        background-color: #000;
        position: relative;
        z-index: 2;
    }

    /* .map-wrapper{
        display: flex;
    }

    .map {
        flex: 0 0 75%;
        max-width: 75%;
    } */
    .slide-section {
        position: fixed;
        top: 0;
        right: 0;
        left: 24%;
        z-index: 10;
        background-color: white;
        min-height: 100vh;
        height: 100vh;
        overflow-y: auto;
        /* padding: 4rem; */
        /* transform: translateX(100%); */
    }

    .close-window i {
        display: block;
        cursor: pointer;
    }

    .slide-section h1{
        font-size: 3.5rem;
    }

    /* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .5s ease;
}
.slide-fade-leave-active {
  /* transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0); */
  transition: all .5s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(100%);
  opacity: 0;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-enter-active {
  transition: all .5s ease;
}
.slide-leave-active {
  /* transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0); */
  transition: all .5s ease;
}
.slide-enter, .slide-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(100%);
  /* opacity: 0; */
}

.slide-overlay {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: .5;
    z-index: 9;
}
</style>
